import { useQuery } from '@tanstack/react-query';
import testHarness from '../api/testHarness';

/**
 * Returns whether the backend is in test-harness mode. Cached so the
 * flag can be checked cheaply from any component. Falls back to `false`
 * on error so the harness UI stays hidden when in doubt.
 */
export default function useHarnessEnabled() {
  const { data } = useQuery({
    queryKey: ['harness-enabled'],
    queryFn:  testHarness.enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return Boolean(data?.enabled);
}
